var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloserIcon = function SvgCloserIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "9px",
    viewBox: "0 0 14 9",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Down")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone8-18",
    transform: "translate(-320.000000, -86.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Events",
    transform: "translate(10.000000, -86.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(10.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BTN-Events-2-Copy",
    transform: "translate(300.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5710678,2.98528137 L11.5710678,10.5710678 C11.5710678,11.1233526 11.1233526,11.5710678 10.5710678,11.5710678 L2.98528137,11.5710678 C2.43299662,11.5710678 1.98528137,11.1233526 1.98528137,10.5710678 C1.98528137,10.3058513 2.09063821,10.0514974 2.27817459,9.86396103 L6.04633901,6.09579661 L9.86396103,2.27817459 C10.2544853,1.8876503 10.8876503,1.8876503 11.2781746,2.27817459 C11.465711,2.46571097 11.5710678,2.72006488 11.5710678,2.98528137 Z",
    id: "Down",
    transform: "translate(6.778175, 6.778175) rotate(-315.000000) translate(-6.778175, -6.778175) "
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloserIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closerIcon.b20d6388.svg";
export { ForwardRef as ReactComponent };